module.exports = __webpack_public_path__ + "static/img/8areaB_11.6e5be76.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_11.png
// module id = 1240
// module chunks = 1